import { Reveal } from "./Reveal";

export const SectionHeading = ({ eyebrow, title, text, dark = false, className = "" }) => (
  <div className={`max-w-2xl ${className}`}>
    <Reveal>
      <p className={`eyebrow ${dark ? "text-terracotta" : "text-terracottaD"}`} data-testid="section-eyebrow">
        {eyebrow}
      </p>
    </Reveal>
    <Reveal delay={0.08}>
      <h2 className={`font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight leading-[1.1] mt-4 ${dark ? "text-cream" : "text-ink"}`}>
        {title}
      </h2>
    </Reveal>
    {text && (
      <Reveal delay={0.16}>
        <p className={`text-base sm:text-lg leading-relaxed mt-5 ${dark ? "text-cream/70" : "text-slate2"}`}>{text}</p>
      </Reveal>
    )}
  </div>
);
